import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	action: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'cross-join-nudges.request-access-error-flag.title',
		defaultMessage: "We couldn't add you to {productDisplayName}",
		description: 'Title of invite error flag',
	},
	description: {
		id: 'cross-join-nudges.request-access-error-flag.description',
		defaultMessage: "Try again in a few minutes. If you still aren't able to join, ",
		description: 'Description informing the user that request to join was not successfully sent',
	},
	action: {
		id: 'cross-join-nudges.request-access-error-flag.action',
		defaultMessage: 'contact support',
		description: 'Action to contact suport',
	},
});
